export const STATIONS_LIST = 'STATIONS_LIST'

export const STATIONS_TYPE = {
  EXTERNAL: 1, //Trung tâm đăng kiểm
  INTERNAL: 2, //Nội bộ TTDK
  GARAGE: 3, //Garage bảo dưỡng
  HELPSERVICE: 4, //Cứu hộ ô tô
  INSURANCE: 5, // Đơn vị Bảo hiểm
  CONSULTING: 6, // Đơn vị tư vấn
  AFFILIATE: 7, // Đơn vị liên kết
  ADVERTISING: 8, // Đơn vị quảng cáo
  COOPERATIVE: 9, // Hợp tác xã
  USED_VEHICLES_DEALERSHIP: 10, // Đơn vị mua bán xe cũ
  SPARE_PARTS_DEALERSHIP: 11, // Mua bán phụ tùng ô tô
  PARKING_LOT: 12, // Bãi giữ xe
  VEHICLE_MODIFICATION: 13, // Đơn vị cải tạo xe
  DRIVING_SCHOOL: 14, // Trường học lái xe
  CHAUFFEUR_SERVICE: 15, // Dịch vụ lái xe hộ
  PARTS_MANUFACTURING_CONSULTANCY: 16, // Tư vấn sản xuất phụ tùng xe
  DRIVER_HEALTH: 17, //  Khám sức khoẻ lái xe
  SHOWROOM: 18, // Showroom
  CUA_HANG_RUA_XE_OTO: 19, // Cửa hàng rửa xe ô tô
  CHUYEN_GIA_HO_TRO: 20, // Chuyên gia hỗ trợ
  HANG_XE: 21, // Hãng xe
  BEN_XE: 22, // Bến xe
  TRAFFIC_POLICE: 23, // Trụ sở CSGT
  TRAFFIC_CAMERA: 24, // Điểm Camera giao thông
  EMERGENCY_HOTLINE: 25, // Hỗ trợ Khẩn cấp (đường dây nóng)
  VEHICLE_CARE: 26 // Chăm sóc xe
}
